/**
 * @generated SignedSource<<9148fa7365ffcf4ad0c1a3f699ec435d>>
 * @relayHash 78c0e49d87fae6f8c6c2b10e4a928391
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a0fbb15897e38c345cea820050ae49354186e46bd773242770ee4d6098aef85a

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TelepointerAgentAvatarQuery$variables = {
  accountId: string;
  shouldFetchAvatar: boolean;
};
export type TelepointerAgentAvatarQuery$data = {
  readonly user?: {
    readonly name: string;
    readonly picture: AGG$URL;
    readonly " $fragmentSpreads": FragmentRefs<"avatarRelay_user">;
  } | null;
};
export type TelepointerAgentAvatarQuery = {
  response: TelepointerAgentAvatarQuery$data;
  variables: TelepointerAgentAvatarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shouldFetchAvatar"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "picture"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "TelepointerAgentAvatarQuery",
    "selections": [
      {
        "condition": "shouldFetchAvatar",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "avatarRelay_user"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TelepointerAgentAvatarQuery",
    "selections": [
      {
        "condition": "shouldFetchAvatar",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isUser"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "appType"
                  }
                ],
                "type": "AppUser"
              },
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a0fbb15897e38c345cea820050ae49354186e46bd773242770ee4d6098aef85a",
    "metadata": {},
    "name": "TelepointerAgentAvatarQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "961936bad4c744afce14f3ee5d0eafcc";

export default node;
